<flowaccount-box-format [boxList]="boxListIntro"></flowaccount-box-format>

<flowaccount-job-openning></flowaccount-job-openning>

<flowaccount-perk></flowaccount-perk>

<flowaccount-our-software></flowaccount-our-software>

<flowaccount-mission></flowaccount-mission>

<flowaccount-box-format [boxList]="boxListAboutUs"></flowaccount-box-format>

<flowaccount-tech-logo></flowaccount-tech-logo>

<flowaccount-dev-benefit></flowaccount-dev-benefit>

<flowaccount-investor></flowaccount-investor>

<flowaccount-tech-blog [blogList]="blogTechList"></flowaccount-tech-blog>

<!-- ซ่อนไปก่อน อัพเดทเมื่อ มกราคม 2023 -->
<ng-container *ngIf="false">
  <flowaccount-box-format [boxList]="boxListHrAccountant"></flowaccount-box-format>
  <flowaccount-job-position></flowaccount-job-position>
  <flowaccount-box-format [boxList]="boxListRecruitment"></flowaccount-box-format>
</ng-container>
